import { render } from "./TableRow.vue?vue&type=template&id=9971f952&scoped=true&ts=true"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"

import "./table-row.scss?vue&type=style&index=0&id=9971f952&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9971f952"]])

export default __exports__